<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p class="dialog-text">{{data.text}}</p>
</div>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>No
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" [mat-dialog-close]="data" (click)="confirm()">
    <mat-icon>check</mat-icon>Si
  </button>
</div>
